
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal/[tenant]/[language]/no-user-segmentation/[preview]/[...pageIdParts]",
      function () {
        return require("private-next-pages/internal/[tenant]/[language]/no-user-segmentation/[preview]/[...pageIdParts].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal/[tenant]/[language]/no-user-segmentation/[preview]/[...pageIdParts]"])
      });
    }
  